export const isEmptyOrSpacesOnly = (categoryName: string) => {
  return !categoryName.replace(/\s/g, "").length;
};
